/**
 * Ids and routes for the integrations API rail panel (LOA-1473).
 *
 * @module app/integrationsApi
 *
 * @remarks
 * Kept apart from `constants.ts` so the layout can use them without pulling in
 * the panel specs and their design-system imports.
 */

/** The rail panel for the integration API (platform operators only). */
export const INTEGRATIONS_API_PANEL_ID = "integrations-api";

/** The `/settings/<screen>` pages that belong to this panel, each also its nav item's id. */
export const SUPER_ADMIN_SETTINGS_SCREENS: ReadonlySet<string> = new Set([
  "integration-keys",
  "integration-routes",
  "feature-toggles",
]);

/** Where a click on the integration API rail icon goes. */
export const INTEGRATIONS_API_HOME_ROUTE = "/settings/feature-toggles";
